import React from "react"

import StoryblokLink from "../shared/StoryblokLink"

import { renderCardHeadline } from "../contentEdit"

import { ThreeCardWhitepaper } from '../../types'

type ThreeBlockWhitepaperProps = {
  full_slug: string
  content: ThreeCardWhitepaper
  ctaLabel?: string
}

const ThreeBlockWhitepaper = ({
  full_slug,
  content,
  ctaLabel = 'Read more'
}: ThreeBlockWhitepaperProps) => {
  const linkObject = {
    cached_url: full_slug,
    linktype: "story",
  }

  const cardHeadline = renderCardHeadline(
    content?.title,
    "c-threeBlock__heading"
  )

  return (
    <StoryblokLink
      to={linkObject}
      className="c-threeBlock__item d-flex flex-column"
    >
      <div className="c-threeBlock__hoverWrapper">
        <div
          className="c-threeBlock__imageWrapper"
          style={{ backgroundImage: `url(${content?.image.filename})` }}
        />

        <div className="c-threeBlock__content">
          <span className="c-threeBlock__type">{content?.component}</span>

          {cardHeadline}

          <span className="btn-tertiary hover-bcgUnderline">{ctaLabel}</span>
        </div>
      </div>
    </StoryblokLink>
  )
}

export default ThreeBlockWhitepaper
